export class TotalizadorDetalhes {

    public id: number;
    public nome: string;
    public original = 0.;
    public paralelo = 0.;
    public lubrificante = 0.;
    public pneu = 0.;

    constructor(id: number, nome: string) {
        this.id = id;
        this.nome = nome;
    }

}
